module.exports = __webpack_public_path__ + "static/mzdy-c70d635fe59ed79adc9ab0840bac77ff.svg";